import { useSelector, useDispatch } from 'react-redux';
import { load, add, remove, toggle } from '../Actions/Favorites.action';

export const useFavorites = () => {
    const dispatch = useDispatch();
    const { items, loading, error, isLocalMode } = useSelector(state => state.favorites);

    const isFavorite = (item) => items.includes(item);

    const addFavorite = (item, productData) => dispatch(add(item, productData));

    const removeFavorite = (item, productData) => dispatch(remove(item, productData));

    const toggleFavorite = (item, productData) => dispatch(toggle(item, productData));

    const loadFavorites = () => dispatch(load());

    return {
        favorites: items,
        loading,
        error,
        isLocalMode,
        isFavorite,
        addFavorite,
        removeFavorite,
        toggleFavorite,
        loadFavorites
    };
};
